import { easeInCubic, easeInExpo } from "easing-utils";
import { Drawable } from "./drawable";
import { ScreenState } from "./screen";
import { rgb } from "../utils/color";

class GameManual extends Drawable{
  /**
  * Initialiases the Game Manual drawable. Designed to be displayed on the first screen.
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */
  constructor(img1, img2, img3, configureCanvas){
    super(0, 0, configureCanvas);
    this.img1 = img1;
    this.img2 = img2;
    this.img3 = img3;
  }

  /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  configure(screenState){
  }

  /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  render(screenState) {
    super.render(screenState);
    const timeSinceInit = screenState.animationStep - this.initTime;
    if (timeSinceInit < 500){
      screenState.canvasCtx.globalAlpha = 0
    }
    else if (timeSinceInit >= 500 < 1500){
      screenState.canvasCtx.globalAlpha = easeInCubic((timeSinceInit-500)/1000)
    }
    else{
      screenState.canvasCtx.globalAlpha = 1;
    }

    // if (timeSinceInit >= 750 && this.player.isPlaying){//Safari has no volume control, thus must stop music.
    //   this.player.requestPause();
    // }
    if (screenState.gameMode == 'webcam'){
      const instructions = screenState.lang === 'en' ? [
        '1. Ensure there is only 1 person in frame.',
        '   For the best experience, have an empty background.',
        '2. Stand or sit 0.\u20055 metres away from your webcam.',
        '3. Ensure your upper body is visible in the webcam,',
        '   Curling your hand like knocking a door may make it easier. ',
        '4. Click on buttons by hovering your hand over them.',
        '5. When the timing is right, tap the lyric using your hand.',
        '(Double click with mouse to toggle full screen)'
      ] : [
        '1. 画面に1人だけが映るようにしてください。',
        '   背景はできるだけ何もない方が望ましいです。',
        '2. ウェブカメラから約0.5メートル離れてください。',
        '3. 上半身が映るようにしてください。',
        '   手をドアをノックする形にすると操作しやすくなります。',
        '4. 手をボタンの上にかざしてクリックします。',
        '5. タイミングに合わせて歌詞をタップしてください。',
        '（マウスでダブルクリックすると全画面表示を切り替えられます）'
      ];
      // screenState.canvasCtx.imageSmoothingEnabled = false;
      const img1Height = this.img1.height/8;
      this.img1.render(screenState.canvasCtx, ...screenState.rectResizeV2Static(20, 20, this.img1.width/8, img1Height))
      const img2Bounding = screenState.rectResizeV2Static(20, 20 + img1Height + screenState.S(20), this.img2.width/8, this.img2.width/8);
      this.img2.render(screenState.canvasCtx, ...img2Bounding)
      // screenState.canvasCtx.imageSmoothingEnabled = true;

      const img3Width = this.img3.width/5
      const img3Height = this.img3.height/5
      this.img3.render(screenState.canvasCtx, ...screenState.rectResize(1400-img3Width, 300-img3Height/2, img3Width, img3Height))
      
      screenState.canvasCtx.fillStyle = rgb(255, 87, 20);
      screenState.canvasCtx.font = `${screenState.S(24)}px Yusei Magic`
      screenState.canvasCtx.textAlign = 'left';
      screenState.canvasCtx.textBaseline = 'bottom';
      let text_instructions_width = 0;
      let textHeights = new Array();
      for (let i = instructions.length-1; i >= 0; i--){
        const text_instructions_bounding = screenState.canvasCtx.measureText(instructions[i]);
        text_instructions_width = Math.max(text_instructions_width, text_instructions_bounding.width);
        textHeights.push(text_instructions_bounding.actualBoundingBoxAscent + text_instructions_bounding.actualBoundingBoxDescent + screenState.S(2))
      }
      const baseXpos = Math.max(screenState.X(780)-text_instructions_width/2, img2Bounding[0] + img2Bounding[2] + screenState.S(15))
      const baseYpos = screenState.Y(690)
      let heightAccumulator = 0;
      for (let i = instructions.length-1; i >= 0; i--){
        screenState.canvasCtx.fillText(instructions[i], baseXpos, baseYpos - heightAccumulator);
        heightAccumulator += textHeights[i]
      }

      // screenState.canvasCtx.beginPath();
    }
    else{
      const instructions = screenState.lang === 'en' ? [
        '1. Click on buttons by hovering your cursor over them.',
        '2. When the timing is right, tap or hover your cursor over the lyric.',
        '(Double click/tap to toggle full screen in game menus)'
      ] : [
        '1. 手をカーソルの上にかざしてクリックします。',
        '2. タイミングに合わせて、歌詞にタップまたはカーソルを重ねます',
        '（メニュー画面でダブルクリック／タップで全画面表示を切り替えられます）'
      ]
      screenState.canvasCtx.fillStyle = rgb(255, 87, 20);
      screenState.canvasCtx.font = `${screenState.S(28)}px Yusei Magic`
      screenState.canvasCtx.textAlign = 'left';
      screenState.canvasCtx.textBaseline = 'bottom';
      let text_instructions_width = 0;
      let textHeights = new Array();
      for (let i = instructions.length-1; i >= 0; i--){
        const text_instructions_bounding = screenState.canvasCtx.measureText(instructions[i]);
        text_instructions_width = Math.max(text_instructions_width, text_instructions_bounding.width);
        textHeights.push(text_instructions_bounding.actualBoundingBoxAscent + text_instructions_bounding.actualBoundingBoxDescent + screenState.S(2))
      }
      const baseXpos = screenState.X(710)-text_instructions_width/2
      const baseYpos = screenState.Y(700)
      let heightAccumulator = 0;
      for (let i = instructions.length-1; i >= 0; i--){
        screenState.canvasCtx.fillText(instructions[i], baseXpos, baseYpos - heightAccumulator);
        heightAccumulator += textHeights[i]
      }
    }
    screenState.canvasCtx.globalAlpha = 1;
  }
}

export default GameManual;